import script from "./Rain3DController.vue?vue&type=script&setup=true&lang=js"
export * from "./Rain3DController.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__